import { get as _get } from 'lodash';
import { useStore } from '@/store';
import { AclAccessLevelEnum, AclMemberRole, AclRole } from '@/services/models/Enums';
import pageAccessSettings from './page-access-settings';

const getUserRole = (isMember: boolean) => (isMember ? AclRole.member : AclRole.user);

const getMemberRole = (role: string) => {
  if (role === 'user') {
    return AclMemberRole.memberUser;
  }
  if (role === 'admin') {
    return AclMemberRole.memberAdmin;
  }
  return false;
};

export const canAccessPage = (page: string) => {
  const store = useStore();
  const user = store.user;

  if (page === 'profile.custom-conversions') {
    if (!user?.isMember) {
      return true;
    }
    return !!user.accessCustomConversions;
  }

  const userRole = getUserRole(Boolean(user?.isMember));
  const memberRole = user ? getMemberRole(user.role) : false;

  const accessRights = _get(pageAccessSettings, page, pageAccessSettings['*']);
  const result = () => {
    if (typeof accessRights === 'string') {
      return accessRights;
    }
    if (memberRole && accessRights[memberRole]) {
      return accessRights[memberRole];
    }
    if (accessRights[userRole]) {
      return accessRights[userRole];
    }
    if (accessRights['*']) {
      return accessRights['*'];
    }

    return pageAccessSettings['*'];
  };

  return result() !== AclAccessLevelEnum.deny;
};
